import * as React from 'react';
import Measure from 'react-measure';

import type { ProgressBarSvgProps } from './ProgressBarSvg';
import ProgressBarSvg from './ProgressBarSvg';

export type ProgressBarProps = ProgressBarSvgProps;

/**
 * A responsive progress bar component that adjusts to container width
 *
 * @component
 * @param {ProgressBarProps} props - Props inherited from ProgressBarSvg component
 * @returns {JSX.Element} A progress bar that fills its container width
 */
const ProgressBar = (props: ProgressBarProps): JSX.Element => {
  return (
    <Measure client bounds>
      {({ measureRef, contentRect }) => (
        <div ref={measureRef} style={{ width: '100%', lineHeight: 0 }}>
          {contentRect?.bounds?.width !== undefined && <ProgressBarSvg width={contentRect?.bounds.width} {...props} />}
        </div>
      )}
    </Measure>
  );
};

/**
 * A placeholder version of the ProgressBar without progress indicators
 * Used for loading states or when progress data is not available
 *
 * @component
 * @returns {JSX.Element} An empty progress bar that fills its container width
 */
const Placeholder = (): JSX.Element => (
  <Measure client bounds>
    {({ measureRef, contentRect }) => (
      <div ref={measureRef} style={{ width: '100%', lineHeight: 0 }}>
        {contentRect?.bounds?.width !== undefined && <ProgressBarSvg width={contentRect?.bounds.width} />}
      </div>
    )}
  </Measure>
);

Placeholder.displayName = 'ProgressBar.Placeholder';
ProgressBar.Placeholder = Placeholder;

export default ProgressBar;
